import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  IconButton,
  Chip,
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import EmailIcon from "@material-ui/icons/Email";
import { AgreementStatus } from "../../../../enums/enums";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import CancelScheduleSendIcon from "@material-ui/icons/CancelScheduleSend";
import Tooltip from "@material-ui/core/Tooltip";
import { RenewalStatus as RenewalStatusEnum } from "../../../../enums/enums";

export default function AgreementsTable({
  Data,
  ConfirmFunction,
  DeleteFunction,
  EmailFunction,
  CancelRenewal,
  ViewFunction,
  IsAdmin,
}) {
  const tableSize = IsAdmin ? undefined : "small";

  function RenderButtons({ Status, Id, Email, RenewalStatus }) {
    let response = <></>;
    switch (Status) {
      case AgreementStatus.Pending.Id:
        !IsAdmin &&
          (response = (
            <Tooltip title="Confirmar">
              <IconButton
                className="c-grid-btn-success button-grid"
                onClick={() => ConfirmFunction(Id)}
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
          ));
        break;
      case AgreementStatus.Confirmed.Id:
        response = (
          <>
            <Tooltip title="Dar de baja">
              <IconButton
                className="c-grid-btn-cancel button-grid"
                onClick={() => DeleteFunction(Id)}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Reenviar términos y condiciones">
              <IconButton
                className="c-grid-btn-info button-grid"
                onClick={() => EmailFunction(Id, Email)}
              >
                <EmailIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Cancelar renovación">
              <IconButton
                disabled={RenewalStatus === RenewalStatusEnum.Disabled}
                className="c-grid-btn-danger button-grid"
                onClick={() => CancelRenewal(Id)}
              >
                <CancelScheduleSendIcon />
              </IconButton>
            </Tooltip>
          </>
        );
        break;
    }

    return response;
  }

  function RenderStatus({ Status }) {
    let text = "";
    let className = "c-chip-";

    switch (Status) {
      case AgreementStatus.Pending.Id:
        text = AgreementStatus.Pending.Text;
        className += "pending";
        break;
      case AgreementStatus.Confirmed.Id:
        text = AgreementStatus.Confirmed.Text;
        className += "confirmed";
        break;
      case AgreementStatus.Canceled.Id:
        text = AgreementStatus.Canceled.Text;
        className += "canceled";
        break;
      case AgreementStatus.Expired.Id:
        text = AgreementStatus.Expired.Text;
        className += "expired";
        break;
      case AgreementStatus.NotRenewed.Id:
        text = AgreementStatus.NotRenewed.Text;
        className += "notrenewed";
    }

    return <Chip size="small" className={className} label={text} />;
  }

  return (
    <TableContainer>
      <Table size={tableSize}>
        <TableHead>
          <TableRow>
            <TableCell className={`c-w-2 ${IsAdmin ? `c-size-custom` : ``}`}>
              N° Contrato
            </TableCell>
            <TableCell className={!IsAdmin ? "c-w-20" : "c-w-5 c-size-custom"}>
              Cliente
            </TableCell>
            <TableCell className={!IsAdmin ? "c-w-5" : "c-w-3 c-size-custom"}>
              Documento
            </TableCell>
            <TableCell className={!IsAdmin ? "c-w-5" : "c-w-5 c-size-custom"}>
              Estado
            </TableCell>
            <TableCell className={!IsAdmin ? "c-w-20" : "c-w-5 c-size-custom"}>
              Compañía
            </TableCell>
            <TableCell className={!IsAdmin ? "c-w-25" : "c-w-5 c-size-custom"}>
              Producto
            </TableCell>
            <TableCell className={!IsAdmin ? "c-w-10" : "c-w-5 c-size-custom"}>
              Canal de Venta Externo
            </TableCell>
            {IsAdmin && (
              <>
                <TableCell className="c-w-3 c-size-custom">
                  Fecha de Primer Contrato
                </TableCell>
                <TableCell className="c-w-3 c-size-custom">
                  Fecha de Confirmación
                </TableCell>
                <TableCell className="c-w-3 c-size-custom">
                  Fecha de Caducidad
                </TableCell>
                <TableCell className="c-w-3 c-size-custom">
                  Fecha de Cancelación
                </TableCell>
              </>
            )}
            <TableCell className={`c-w-30 ${IsAdmin ? `c-size-custom` : ``}`}>
              Opciones
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Data.map(
            ({
              number,
              customer,
              product,
              compania,
              documentNumber,
              status,
              email,
              confirmedDate,
              firstAgreementDate,
              expirationDate,
              renewalStatus,
              cancellationDate,
              externalSalesChannel,
            }) => (
              <TableRow key={number}>
                <TableCell className="c-w-2">{number}</TableCell>
                <TableCell className="c-w-20">{customer}</TableCell>
                <TableCell className="c-w-5">{documentNumber}</TableCell>
                <TableCell className="c-w-5">
                  <RenderStatus Status={status} />
                </TableCell>
                <TableCell className="c-w-5">{compania}</TableCell>
                <TableCell className="c-w-5">{product}</TableCell>
                <TableCell className="c-w-5">{externalSalesChannel}</TableCell>
                {IsAdmin && (
                  <>
                    <TableCell className="c-w-5">
                      {firstAgreementDate}
                    </TableCell>
                    <TableCell className="c-w-5">{confirmedDate}</TableCell>
                    <TableCell className="c-w-5">{expirationDate}</TableCell>
                    <TableCell className="c-w-5">{cancellationDate}</TableCell>
                  </>
                )}
                <TableCell className="c-w-45 c-table-small-padding">
                  <Tooltip title="Ver">
                    <IconButton
                      className="c-grid-btn-info button-grid"
                      onClick={() => ViewFunction(number)}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>

                  <RenderButtons
                    Status={status}
                    Id={number}
                    Email={email}
                    RenewalStatus={renewalStatus}
                  />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
